import { useState } from "react";
import { ArrowUpDown, CheckCircle, Loader2, Package, RefreshCw, XCircle } from "lucide-react";
import { CarregandoBloco, CarregandoLista } from "../../../components/carregando";
import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";
import { imageUrl } from "../api";
import useIfoodCatalog from "./useIfoodCatalog";
import VincularItemDialog from "./VincularItemDialog";
import CasarCodigosCard from "./CasarCodigosCard";

function ProdutoRow({ p, mapping, onUnmap, onLink }) {
  const off = p.available === false;
  const hasIfood = (p.visible_modules || []).some((v) => String(v).toLowerCase() === "ifood");
  return (
    <div className={`p-3 rounded-xl border bg-card flex items-center justify-between gap-3 ${off ? "opacity-60" : ""}`}>
      <div className="flex items-center gap-3 min-w-0 flex-1">
        {p.photo_url ? (
          <img src={imageUrl(p.photo_url)} alt="" className="w-10 h-10 rounded-lg object-cover shrink-0 bg-muted" onError={(e) => { e.currentTarget.style.visibility = "hidden"; }} />
        ) : (
          <div className="w-10 h-10 rounded-lg bg-muted flex items-center justify-center shrink-0"><Package className="w-5 h-5 text-muted-foreground" /></div>
        )}
        <div className="min-w-0">
          <p className="font-medium text-sm truncate">{p.name}</p>
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <span>R$ {Number(p.sale_price || 0).toFixed(2).replace(".", ",")}</span>
            {off && <span className="px-1.5 py-0.5 rounded bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400">Desativado</span>}
            {hasIfood && <span className="px-1.5 py-0.5 rounded bg-red-100 text-red-600 dark:bg-red-900/30 dark:text-red-400">iFood</span>}
          </div>
        </div>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        {mapping ? (<>
          <div className="text-right">
            <p className="flex items-center gap-1 text-xs text-green-600 dark:text-green-400 font-medium"><CheckCircle className="w-3.5 h-3.5" /> Vinculado</p>
            <p className="text-[10px] text-muted-foreground truncate max-w-[140px]">{mapping.ifood_item_name || mapping.ifood_item_id?.slice(0, 8)}</p>
          </div>
          <Button variant="ghost" size="sm" className="h-7 px-2 text-red-500 hover:text-red-700" onClick={() => onUnmap(p.id)} title="Desvincular"><XCircle className="w-3.5 h-3.5" /></Button>
        </>) : (
          <Button variant="outline" size="sm" className="h-7 px-3 text-xs" onClick={() => onLink(p)}>Vincular</Button>
        )}
      </div>
    </div>
  );
}

export default function CatalogoTab() {
  const cat = useIfoodCatalog();
  const [q, setQ] = useState("");
  const [linking, setLinking] = useState(null);

  const openLink = async (p) => {
    setLinking(p);
    if (cat.ifoodItems.length === 0) await cat.loadIfoodItems();
  };
  const pick = async (product, item) => { if (await cat.map(product, item)) setLinking(null); };
  const byProduct = Object.fromEntries(cat.mappings.map((m) => [m.product_id, m]));
  const products = cat.products.filter((p) => !q || p.name.toLowerCase().includes(q.toLowerCase()));
  const vinculados = cat.mappings.length;

  // Esqueleto só na 1ª abertura da aba (o hook não volta `loading` ao recarregar).
  if (cat.loading) {
    return (
      <div className="space-y-5">
        <CarregandoBloco altura="h-28" />
        <CarregandoLista linhas={6} colunas={1} />
      </div>
    );
  }

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div>
          <h3 className="font-semibold">Cardápio no iFood</h3>
          <p className="text-sm text-muted-foreground">{vinculados} de {cat.products.length} produtos vinculados{cat.catalogs.length ? ` · ${cat.catalogs.length} catálogo(s) no iFood` : ""}</p>
        </div>
        <div className="flex gap-2">
          <Button onClick={cat.loadIfoodItems} disabled={cat.busy === "items"} variant="outline" size="sm">
            {cat.busy === "items" ? <Loader2 className="w-4 h-4 animate-spin mr-1" /> : <RefreshCw className="w-4 h-4 mr-1" />} Ler cardápio do iFood
          </Button>
          <Button onClick={cat.syncAll} disabled={cat.busy === "sync"} variant="outline" size="sm" title="Pausa no iFood o que está desativado aqui e reativa o que voltou">
            {cat.busy === "sync" ? <Loader2 className="w-4 h-4 animate-spin mr-1" /> : <ArrowUpDown className="w-4 h-4 mr-1" />} Sincronizar disponibilidade
          </Button>
        </div>
      </div>
      <CasarCodigosCard onDone={cat.reload} />
      <div>
        <div className="flex items-center justify-between mb-3">
          <h4 className="text-sm font-semibold">Seus produtos ({products.length})</h4>
          <Input id="ifood-busca-produto" placeholder="Buscar produto…" value={q} onChange={(e) => setQ(e.target.value)} className="w-48 h-8 text-xs" />
        </div>
        <div className="space-y-2 max-h-[520px] overflow-y-auto pr-1">
          {products.map((p) => <ProdutoRow key={p.id} p={p} mapping={byProduct[p.id]} onUnmap={cat.unmap} onLink={openLink} />)}
        </div>
      </div>
      <VincularItemDialog product={linking} items={cat.ifoodItems} loading={cat.busy === "items"} onPick={pick} onClose={() => setLinking(null)} />
    </div>
  );
}
